import API from 'api/API';
import { DraftStatus } from 'api/Responses/SetResponses';
import { useState, useEffect } from 'react';

interface UseReviewList {
  pendingSets: string[];
  pendingDevices: string[];
  loading: boolean;
}

const useReview = (status: DraftStatus): UseReviewList => {
  const [pendingSets, setPendingSets] = useState<string[]>([]);
  const [pendingDevices, setPendingDevices] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [_draftSets, _draftDevices] = await Promise.all([API.set.listPending(status), API.device.listPending()]);
        setPendingSets(_draftSets);
        setPendingDevices(_draftDevices);
      } catch (error) {
        API.errorHandler(error);
      }
      setLoading(false);
    })();
  }, [status]);

  return { pendingSets, pendingDevices, loading };
};

export default useReview;
